export default __webpack_public_path__ + "static/media/Facebook.3e023a0f.svg";